/* eslint-disable */
import axios from "axios";
import { EventBus } from "../../events/eventBus";
import SocketHolder from "../../SocketHolder";
import moment from "moment-timezone";

axios.defaults.headers.common["Content-Type"] = "application/json";

export default {
  namespaced: true,
  state: {
    conversations: [],
    currentConversation: {
      status: null,
      conversation: {},
      messages: [],
      geography: [],
      attachments: [],
      transcriptions: {},
      lastMessageAt: null,
      agent: null,
      lastHat: null,
    },
    lastHat: null,
  },
  getters: {
    activeConversations: (state) => {
      const conversations = state.conversations.sort((c1, c2) => {
        return (c2.last_message_at || c2.updated_at) - c1.last_message_at;
      });
      const activeConversations = conversations.filter(item => item.status === "active");
      const closedConversations = conversations
        .filter(item => item.status === "closed")
        .sort((c1, c2) => new Date(c1.closed_at) - new Date(c2.closed_at));
      return activeConversations.concat(closedConversations);
    },
    activeConversationCount: (state) => state.conversations.length,
    unreadConversations: (state) =>
      state.conversations.filter((conv) => conv.unread > 0).length,
    currentConversation: (state) => state.currentConversation.conversation,
    conversationTranscriptions: (state) =>
      state.currentConversation.transcriptions,
    conversationMessages: (state) => state.currentConversation.messages,
    conversationStatus: (state) => state.currentConversation.status,
    conversationGeography: (state) => state.currentConversation.geography,
    latestGeography: (state) => state.currentConversation.geography[0],
    conversationAttachments: (state) => state.currentConversation.attachments,
    lastMessageAt: (state) => state.currentConversation.lastMessageAt,
    recipientLastHat: (state) => state.lastHat,
  },
  actions: {
    async fetchConversations({ commit }) {
      const resp = await this._vm.$ConveyApi.conversationsApi.getConversations({
        params: {
          status: "active",
          limit: 100,
        }
      });
      const conversations = resp.data.data;
      commit("initializeConversations", conversations);
    },

    async loadConversationAgent({ commit, rootState }, conversation) {
      let agent = null;
      if (conversation.operator_id) {
        try {
          let headers = {
            "x-agency-id": conversation.agency_id,
            Authorization: `Bearer ${rootState.user.token}`,
          };

          let resp = await axios.get(
            `${this._vm.$apihost}/users/${conversation.operator_id}`,
            { headers: headers }
          );

          agent = `${resp.data.data.fname} ${resp.data.data.lname}`;
        } catch (err) {
          console.error("Error looking up user");
        }
      }

      commit("setConversationAgent", agent);
    },

    async loadConversation({ commit, dispatch }, conversation) {
      commit("setConversation", conversation);
      commit("updateConversationState", "success");
      dispatch("loadConversationAgent", conversation);
    },

    async loadMessages({ commit }, messages) {
      commit("setConversationMessages", messages);
    },

    createConversation({ commit }, conversation) {
      commit("addConversation", conversation);
      EventBus.$emit("newConversationEvent", conversation.conversation_id);
    },

    createMessage({ commit }, message) {
      // We already have the conversation open
      if (
        this.state.conversations.currentConversation.status !== null &&
        message.conversation_id ===
          this.state.conversations.currentConversation.conversation
            .conversation_id
      ) {
        commit("addMessage", message);
      } else {
        // Need to increment the unread count on the appropriate conversation
        commit("setUnreadFlag", message.conversation_id);
      }

      if (message.source !== "note") commit("updateRecentMessage", message);
    },

    async sendMessage({ dispatch, rootState }, { message, ttsActive }) {
      if (!message || message == "") {
        return;
      }
      const conversation =
        this.state.conversations.currentConversation.conversation;
      const conversationId = conversation.conversation_id;
      if (!conversationId) {
        alert("Error - Conversation Not Loaded");
        return;
      }

      const headers = {
        Authorization: `Bearer ${rootState.user.token}`,
        "x-agency-id": rootState.agency.agency.agency_id,
        "x-operator-id": rootState.user.user.user_id,
      };

      const request = {
        direction: "outbound",
        body: message.trim(),
        conversation_id: conversationId,
        recipient_number: conversation.primary_recipient,
        operator_id: rootState.user.user.user_id,
        source: ttsActive ? "voice" : "sms",
      };

      await axios
        .post(`${this._vm.$apihost}/messages`, request, { headers })
        .then((resp) => {
          const msg = resp.data.data;
          dispatch("createMessage", msg);

          EventBus.$emit("chat.send-message", {
            conversationId,
            agencyId: rootState.agency.agency.agency_id,
            message,
            source: null,
          });
        })
        .catch((err) => {
          const audio = new Audio("/assets/audio/glitch-in-the-matrix-600.ogg");
          audio.play();
          console.log(err);
        });
    },

    readConversation({ commit }, conversationId) {
      commit("markConversationAsRead", conversationId);
      EventBus.$emit("markConversationAsRead", conversationId);
    },

    unloadConversation({ commit }) {
      SocketHolder.socket.emit(
        "leaveConversation",
        this.state.conversations.currentConversation.conversation
          .conversation_id
      );
      commit("removeCurrentConversation");
    },

    loadGeography({ commit }, geography) {
      commit("updateGeography", geography);
    },

    loadAttachments({ commit }, attachments) {
      commit("setAttachments", attachments);
    },

    upsertAttachment({ commit }, attachment) {
      if (
        this.state.conversations.currentConversation.status !== null &&
        attachment.conversation_id ===
          this.state.conversations.currentConversation.conversation
            .conversation_id
      ) {
        commit("addAttachment", attachment);
      }
    },
  },
  mutations: {
    updateRecentMessage: (state, message) => {
      const index = state.conversations.findIndex(
        (convo) => convo.conversation_id === message.conversation_id
      );
      if (index !== -1) {
        state.conversations[index].recent_message =
          message.message_body == "" && message.num_media > 0
            ? "Sent an attachment"
            : message.message_body;
        state.conversations[index].last_message_at = message.created_at;
        state.currentConversation.transcriptions[message.direction] = null;
      }
    },

    updateCurrentConversation: (state, conversation) => {
      state.currentConversation = {
        ...state.currentConversation,
        conversation,
      };
    },

    removeCurrentConversation: (state) => {
      state.currentConversation = {
        status: null,
        conversation: {},
        messages: [],
        geography: [],
        attachments: [],
        transcriptions: {},
        lastMessageAt: null,
        agent: null,
        lastHat: null,
      };
    },

    initializeConversations: (state, conversations) =>
      (state.conversations = conversations),

    setConversation: (state, conversation) => {
      state.currentConversation.conversation = conversation;
      // state.currentConversation.conversation.recipients[0].latest_geography;
      state.currentConversation.conversation.recipients = conversation.recipients;
    },

    setConversationRecipients: (state, recipients) => {
      console.log(state.currentConversation.conversation.recipients);
      console.log([...recipients]);
      state.currentConversation.conversation.recipients = [...recipients];
    },

    setConversationMessages: (state, messages) =>
      (state.currentConversation.messages = messages),

    updateConversationState: (state, status) =>
      (state.currentConversation.status = status),

    addConversationReply: (state, message) =>
      state.currentConversation.messages.push(message),

    addConversation: (state, conversation) => {
      const index = state.conversations.findIndex(
        (convo) => convo.conversation_id === conversation.conversation_id
      );
      if (index !== -1) {
        state.conversations.splice(index, 1, conversation);
      } else {
        state.conversations.unshift(conversation);
      }

      if (
        state.currentConversation.status !== null &&
        state.currentConversation.conversation.conversation_id ===
          conversation.conversation_id
      )
        state.currentConversation.conversation = conversation;
    },

    setMessageStatus: (state, messageStatus) => {
      if (
        messageStatus.conversation_id ===
        state.currentConversation.conversation.conversation_id
      ) {
        const index = state.currentConversation.messages.findIndex(
          (m) => m.message_id === messageStatus.message_id
        );
        if (index !== -1) {
          state.currentConversation.messages[index].status =
            messageStatus.status;
          state.currentConversation.messages[index].error_code =
            messageStatus.error_code;
          state.currentConversation.messages[index].error_message =
            messageStatus.error_message;
        }
      }
    },

    addMessage: (state, message) => {
      const index = state.currentConversation.messages.findIndex(
        (m) => m.message_id === message.message_id
      );

      // Message exists
      if (index !== -1) {
        state.currentConversation.messages.splice(index, 1, message);
        // New Reply
      } else {
        state.currentConversation.messages.push(message);
      }

      state.currentConversation.transcriptions[message.direction] = null;
      state.currentConversation.lastMessageAt = message.created_at;
    },

    setUnreadFlag: (state, conversationId) => {
      state.conversations = state.conversations.map((convo) =>
        convo.id === conversationId
          ? { ...convo, unread: ++convo.unread }
          : convo
      );
    },

    removeConversation: (state, conversationId) => {
      state.conversations = state.conversations.filter(
        (convo) => convo.conversation_id !== conversationId
      );
    },

    closeConversation(state, conversationId) {
      const conversations = [...state.conversations];
      const conversation = conversations.find(item => item.conversation_id === conversationId);
      if (conversation) {
        conversation.status = "closed";
        conversation.closed_at = moment().utc().valueOf();
        state.conversations = [...conversations];
      }
    },

    markConversationAsRead: (state, conversationId) => {
      const index = state.conversations.findIndex(
        (c) => c.conversation_id === conversationId
      );
      if (index !== -1) {
        state.conversations[index].unread = 0;
      } else {
        console.log("Can't find index");
      }
    },

    updateGeography: (state, geography) => {
      if (geography.length > 0) {
        const geog = geography[geography.length - 1];

        try {
          const convoIndex = state.conversations.findIndex(
            (c) => c.recipients[0].recipient_id === geog.recipient_id
          );

          if (
            convoIndex > -1 &&
            state.conversations[convoIndex].conversation_id &&
            state.conversations[convoIndex].recipients[0] &&
            state.conversations[convoIndex].recipients[0].recipient_id ==
              geog.recipient_id
          ) {
            // Set latest location on appropriate conversation object

            // If location matches current conversation, set it
            if (
              state.currentConversation.status !== null &&
              state.currentConversation.conversation.conversation_id ==
                state.conversations[convoIndex].conversation_id
            ) {
              state.currentConversation.geography = geography.concat(
                state.currentConversation.geography
              );
            } else {
              state.conversations[convoIndex].recent_message =
                "Location Received";
            }
          }
        } catch (e) {
          // Do nothing
        }
      }
    },

    setAttachments: (state, attachments) =>
      (state.currentConversation.attachments = attachments),

    addAttachment: (state, attachment) => {
      const index = state.currentConversation.attachments.findIndex(
        (a) => a.attachment_id === attachment.attachment_id
      );
      // Attachment exists
      if (index !== -1) {
        state.currentConversation.attachments.splice(index, 1, attachment);
        // New Attachment
      } else {
        state.currentConversation.attachments.push(attachment);
      }
    },

    updateLastHat: (state, hat) => {
      state.lastHat = hat;
    },

    setConversationAgent: (state, agent) => {
      state.currentConversation.agent = agent;
    },

    addRecipient: (state, recipient) => {
      const c_index = state.conversations.findIndex(
        (c) => c.conversation_id === recipient.conversation_id
      );
      if (c_index !== -1) {
        const r_index = state.conversations[c_index].recipients.findIndex(
          (cr) => cr.recipient_id === recipient.recipient_id
        );
        if (r_index === -1)
          state.conversations[c_index].recipients.push(recipient);
      }
    },

    removeRecipient: (state, recipient) => {
      const c_index = state.conversations.findIndex(
        (c) => c.conversation_id === recipient.conversation_id
      );
      if (c_index != -1) {
        const r_index = state.conversations[c_index].recipients.findIndex(
          (cr) => cr.recipient_id === recipient.recipient_id
        );
        if (r_index !== -1) {
          state.conversations[c_index].recipients = state.conversations[
            c_index
          ].recipients.filter(
            (cr) => cr.recipient_id !== recipient.recipient_id
          );
        }
      }
    },

    updateRecipient: (state, recipient) => {
      const currentConversation = {...state.currentConversation};
      const rIndex = currentConversation.conversation.recipients.findIndex((r) => r.recipient_id === recipient.recipient_id);
      if (rIndex >= 0) {
        currentConversation.conversation.recipients[rIndex] = recipient;
        state.currentConversation = {...currentConversation};
      }
    },

    addTranscription: (state, data) => {
      if (state.currentConversation.status !== null) {
        for (var i = 0; i < data.length; i++) {
          if (
            data[i].conversation_id ===
            state.currentConversation.conversation.conversation_id
          ) {
            state.currentConversation.transcriptions[data[i].direction] =
              data[i];
          }
        }
      }
    },
    
    updateConversation(state, conversation) {
      const findIndex = state.conversations.findIndex(
        convo => convo.conversation_id === conversation.conversation_id
      );
      if (findIndex >= 0) {
        state.conversations.splice(findIndex, 1, conversation);
      }
    }
  },
};
